var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useStylesHook } from "../hooks/useStylesHook";
import { TMS_THEME } from "../theming/theming";
import { calculateBorderRadius } from "../styling/borders.styles";
import { calculateDimension, calculateWidth, } from "../styling/dimensions.styles";
import { calculateColor } from "../styling/colors.styles";
export function useViewStyles(props) {
    var _a;
    return useStylesHook({
        view: __assign(__assign({ margin: calculateMarginSize(props === null || props === void 0 ? void 0 : props.space), marginLeft: calculateMarginSize(props === null || props === void 0 ? void 0 : props.spaceLeft), marginBottom: calculateMarginSize(props === null || props === void 0 ? void 0 : props.spaceBottom), marginRight: calculateMarginSize(props === null || props === void 0 ? void 0 : props.spaceRight), marginTop: calculateMarginSize(props === null || props === void 0 ? void 0 : props.spaceTop), padding: calculateDimension(props === null || props === void 0 ? void 0 : props.padding), paddingLeft: calculateDimension(props === null || props === void 0 ? void 0 : props.paddingLeft), paddingBottom: calculateDimension(props === null || props === void 0 ? void 0 : props.paddingBottom), paddingRight: calculateDimension(props === null || props === void 0 ? void 0 : props.paddingRight), paddingTop: calculateDimension(props === null || props === void 0 ? void 0 : props.paddingTop), border: (props === null || props === void 0 ? void 0 : props.border)
                ? "1px solid ".concat(TMS_THEME.palette.gray.smoke.color)
                : {}, borderLeftWidth: calculateBorderWidth(props === null || props === void 0 ? void 0 : props.borderWidthLeft, !!(props === null || props === void 0 ? void 0 : props.border)), borderBottomWidth: calculateBorderWidth(props === null || props === void 0 ? void 0 : props.borderWidthBottom, !!(props === null || props === void 0 ? void 0 : props.border)), borderRightWidth: calculateBorderWidth(props === null || props === void 0 ? void 0 : props.borderWidthRight, !!(props === null || props === void 0 ? void 0 : props.border)), borderTopWidth: calculateBorderWidth(props === null || props === void 0 ? void 0 : props.borderWidthTop, !!(props === null || props === void 0 ? void 0 : props.border)), backgroundColor: calculateColor(props === null || props === void 0 ? void 0 : props.backgroundColor), borderRadius: calculateBorderRadius(props === null || props === void 0 ? void 0 : props.borderRadius), flex: (_a = props === null || props === void 0 ? void 0 : props.flex) !== null && _a !== void 0 ? _a : {}, boxShadow: (props === null || props === void 0 ? void 0 : props.boxShadow) ? TMS_THEME.root.boxShadow : {}, position: (props === null || props === void 0 ? void 0 : props.position) ? props === null || props === void 0 ? void 0 : props.position : {} }, calculateWidth(props === null || props === void 0 ? void 0 : props.width)), getHover(props === null || props === void 0 ? void 0 : props.hover)),
    });
}
var calculateBorderWidth = function (size, border) {
    if (!border)
        return {};
    switch (size) {
        case "thin":
        case "default":
            return 1;
        case "zero":
            return 0;
        default:
            return border ? 1 : 0;
    }
};
var calculateMarginSize = function (size) {
    if (size === undefined)
        return {};
    if (size === "auto")
        return "auto";
    if (size === "cardZero")
        return -15;
    return calculateDimension(size);
};
var getHover = function (color) {
    if (color === undefined)
        return null;
    return {
        "&:hover": {
            backgroundColor: calculateColor(color),
        },
    };
};
